import { Link } from 'react-router';
import styled from 'styled-components';
import { theme } from '../../utils/Theme';

export const ButtonsContainer = styled.div`
    display: flex;
    justify-content: center;
    margin-top: 2.5rem;
    gap: 1.2rem;

    @media screen and (max-width: 440px) {
        flex-direction: column;
        align-items: center;
    }
`;

export const StyledTitle = styled.h1`
    color: ${theme.greyColorText};
`;
export const StyledText = styled.span`
    color: ${theme.blueColor};
    font-size: 1.5rem;
    text-align: center;
    display: inline-block;
`;

export const CentredDiv = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const ErrorText = styled.span`
    color: ${theme.dangerColor};
    font-size: 1rem;
    text-align: center;
    display: inline-block;
`;

export const Form = styled.form`
    color: ${theme.greyColorText};
    display: flex;
    flex-direction: column;
    align-items: center;
    max-width: 500px;
    width: 100%;
    align-self: center;
    justify-self: center;
    margin-top: 2rem;
`;

export const Input = styled.input`
    color: ${theme.backgroundColor};
    margin-bottom: 1.2rem;
    width: 100%;
    padding: 0.75rem 1.2rem;
    border-radius: 0.4rem;

    &::placeholder {
        color: ${theme.darkColor};
    }
`;

export const ResumeButton = styled.button`
    display: inline-block;
    background-color: inherit;
    min-width: 150px;
    text-align: center;
    width: max-content;
    color: ${theme.blueColor};
    padding: 0.75rem 1.2rem;
    border-radius: 0.4rem;
    cursor: pointer;
    border: 1px solid ${theme.blueColor};
    transition: var(--transition);

    &:hover {
        background: ${theme.whiteColor};
        color: ${theme.backgroundColor};
        border-color: transparent;
    }

    @media screen and (max-width: 450px) {
        padding: 0.5rem 0.75rem;
    }
`;
export const LinkButton = styled(Link)`
    display: inline-block;
    background-color: inherit;
    min-width: 150px;
    text-align: center;
    width: max-content;
    color: ${theme.blueColor};
    padding: 0.75rem 1.2rem;
    border-radius: 0.4rem;
    cursor: pointer;
    border: 1px solid ${theme.blueColor};
    transition: var(--transition);
    font-size: 0.8rem;

    &:hover {
        background: ${theme.whiteColor};
        color: ${theme.backgroundColor};
        border-color: transparent;
    }

    @media screen and (max-width: 450px) {
        padding: 0.5rem 0.75rem;
    }
`;

export const RegistrationButton = styled(ResumeButton)`
    background-color: ${theme.blueColor};
    margin-top: 2rem;
    color: ${theme.backgroundColor};
`;
